'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = flatPath;

var _isPlainObject = require('lodash/isPlainObject');

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function flatPath(obj) {
    if (!obj) {
        return {};
    }
    var hasChanges = false;
    var resultObject = Object.keys(obj).reduce(function (aggr, key) {
        var value = obj[key];
        if ((0, _isPlainObject2.default)(value)) {
            hasChanges = true;
            var newProps = Object.keys(value).reduce(function (acum, valueKey) {
                var resultKey = [key, valueKey].join('/');
                return _extends({}, acum, _defineProperty({}, resultKey, value[valueKey]));
            }, {});
            return _extends({}, newProps, aggr);
        }
        return _extends(_defineProperty({}, key, value), aggr);
    }, {});
    if (!hasChanges) {
        return resultObject;
    }
    return flatPath(resultObject);
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/providers/stub/flatPath.js
// module id = 1499
// module chunks = 1